export const Overview =
  "The Drivado Partner API is a RESTful API designed to facilitate integration with our platform. It is organized around several core resources, including Booking, Vehicle, Payment Method, and others. Each resource is accessible via specific endpoints, with different actions performed through standard HTTP request methods.";

export const Authentication = {
  AccountCreation: (
    <div>
      <p>
        The Drivado team will handle your registration in the Drivado System.
        Once registered, you will receive your login credentials, which include:
      </p>
      <ul>
        <li>
          <strong>1. Username</strong>
        </li>
        <li>
          <strong>2. Password</strong>
        </li>
      </ul>
      <p>
        You can use these credentials to log in at
        <a className="text-blue-800" href="http://www.drivado.com">
          {` www.drivado.com `}
        </a>
        and check all the bookings created from your end.
      </p>
    </div>
  ),
  API_Authentication: (
    <div>
      <p>
        To authenticate API requests, you will need the following credentials:
      </p>
      <ul>
        <li>
          <strong>1. Username</strong>
        </li>
        <li>
          <strong>2. Api Key</strong> ( accepted format in header : apikey)
        </li>
      </ul>
      <br/>
      <p>
        <p>The <strong>Api Key</strong> will be provided from our end</p>
        Please ensure you include these credentials in your API requests to
        access the APIs.
      </p>
    </div>
  ),
  Support: (
    <div>
      <p>
        If you encounter any issues related to API integration, please contact
        us at{" "}
        <a className="text-blue-800" href="mailto:support@drivado.com">
          support@drivado.com
        </a>
        .
      </p>
    </div>
  ),
};
